export const DEFI5 = "0xfa6de2697D59E88Ed7Fc4dFE5A33daC43565ea41"

export const CC10 = "0x17aC188e09A7890a1844E5E65471fE8b0CcFadF3"

export const FFF = "0xaBAfA52D3d5A2c18A4C1Ae24480D22B831fC0413"

export const UNIBURN = "0x589f9D287766d810aafcCAEe3A133f22C13EB6F8"

export const REDEMPTION_LENS = "0xb8bd900c588325fb657cb37d416f69b6815020a9"

export const POOLS = {
  defi5: DEFI5,
  cc10: CC10,
  fff: FFF,
}

export const UNISWAP_PAIRS = {
  defi5: "0x8dCBa0B75c1038c4BaBBdc0Ff3bD9a8f6979Dd13",
  cc10: "0x2701eA55b8B4f0FE46C15a0F560e9cf0C430f833",
  fff: "0x9A60F0A46C1485D4BDA7750AdB0dB1b17Aa48A33",
}

export const PAIR_POOLS = {
  [UNISWAP_PAIRS.defi5]: DEFI5,
  [UNISWAP_PAIRS.cc10]: CC10,
  [UNISWAP_PAIRS.fff]: FFF,
}

export const POOL_TOKENS = {
  defi5: [
    "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
    "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
    "0xc00e94Cb662C3520282E6f5717214004A7f26888",
    "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
    "0xD533a949740bb3306d119CC777fa900bA034cd52",
    "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
    "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2"
  ],
  cc10: [
    "0x514910771AF9Ca656af840dff83E8264EcF986CA",
    "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
    "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
    "0xc00e94Cb662C3520282E6f5717214004A7f26888",
    "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
    "0xD533a949740bb3306d119CC777fa900bA034cd52",
    "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
    "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
    "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
    "0x0D8775F648430679A709E98d2b0Cb6250d2887EF",
    "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
    "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07"
  ],
  fff: [
    "0xfa6de2697D59E88Ed7Fc4dFE5A33daC43565ea41",
    "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
    "0x126c121f99e1E211dF2e5f8De2d96Fa36647c855",
    "0x17aC188e09A7890a1844E5E65471fE8b0CcFadF3"
  ]
}

export const TOKEN_SYMBOLS: Record<string, string> = {
  "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984": "UNI",
  "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9": "AAVE",
  "0xc00e94Cb662C3520282E6f5717214004A7f26888": "COMP",
  "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F": "SNX",
  "0xD533a949740bb3306d119CC777fa900bA034cd52": "CRV",
  "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2": "MKR",
  "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2": "SUSHI",
  "0x514910771AF9Ca656af840dff83E8264EcF986CA": "LINK",
  "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e": "YFI",
  "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828": "UMA",
  "0x0D8775F648430679A709E98d2b0Cb6250d2887EF": "BAT",
  "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07": "OMG",
  "0xfa6de2697D59E88Ed7Fc4dFE5A33daC43565ea41": "DEFI5",
  "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2": "WETH",
  "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599": "WBTC",
  "0x126c121f99e1E211dF2e5f8De2d96Fa36647c855": "DEGEN",
  "0x17aC188e09A7890a1844E5E65471fE8b0CcFadF3": "CC10",
  "0xaBAfA52D3d5A2c18A4C1Ae24480D22B831fC0413": "FFF",
  "0x8dCBa0B75c1038c4BaBBdc0Ff3bD9a8f6979Dd13": "ETH-DEFI5",
  "0x2701eA55b8B4f0FE46C15a0F560e9cf0C430f833": "ETH-CC10",
  "0x9A60F0A46C1485D4BDA7750AdB0dB1b17Aa48A33": "ETH-FFF"
}

export const STAKING_TOKENS: Record<string, number> = {
  "0xfa6de2697D59E88Ed7Fc4dFE5A33daC43565ea41": 0,
  "0x17aC188e09A7890a1844E5E65471fE8b0CcFadF3": 1,
  "0x126c121f99e1E211dF2e5f8De2d96Fa36647c855": 2,
  "0x8dCBa0B75c1038c4BaBBdc0Ff3bD9a8f6979Dd13": 3,
  "0x2701eA55b8B4f0FE46C15a0F560e9cf0C430f833": 4,
  "0xf58d2BacbC68C587730eA0cE5131F6ae7c622a5D": 5,
  "0xFaAD1072E259B5ED342D3f16277477B46D379ABC": 6,
  "0x44Ee3377D27Bd28518Bfe625AE922af2d58F57dD": 7,
  "0x9A60F0A46C1485D4BDA7750AdB0dB1b17Aa48A33": 8,
  "0x974Ea1b7f459a46cB8DA5131Dd0F98492C5a0988": 9,
}
export const MULTI_TOKEN_STAKING = "0xC46E0E7eCb3EfCC417f6F89b940FFAFf72556382"
